import { createSlice } from "@reduxjs/toolkit";

import {
  getWishlistCount,
  getWishlistProducts,
} from "../../reduxApi/website/WishlistApi";

const WishlistSlice = createSlice({
  name: "CartCount",
  initialState: {
    status: "idle",
    WishListCount: [],
    WishListProducts: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getWishlistCount.fulfilled, (state, action) => {
      state.status = "fulfilled";
      state.WishListCount = action.payload.data;
      // console.log("WishListCount:", state.WishListCount);
    });
    builder.addCase(getWishlistProducts.fulfilled, (state, action) => {
      state.status = "fulfilled";
      state.WishListProducts = action.payload.data;
      // console.log("WishListProducts", state.WishListProducts);
    });
  },
});

export default WishlistSlice.reducer;
